export default "__VITE_ASSET__D9ZemcdZ__"